import React from 'react';

const Hero2 = () => {
  return (
    <div className="hero2">
      <div className="hero2__header">
        <h1>Accelerating the Next Generation of AI</h1>
      </div>
      <div className="hero2__subhead">
        <p>
          UK-based Sunlight.io and US-based Pathr.ai are two companies participating in Lenovo’s AI
          Innovators program, which is designed to scale up breakthroughs in artificial intelligence
          applications from the edge to the cloud. The companies help AI-powered computer vision
          improve customer service and pedestrian traffic flow, highlighting edge AI’s potential to
          enhance the lives of millions.
        </p>
      </div>
    </div>
  );
};

export default Hero2;
